import { useState, useCallback } from 'react'

import { Icon, TextLink } from '@circlefin/components'
import useTranslation from 'next-translate/useTranslation'

import { useSettlementCreditLine } from '../../hooks/settlement-credit-line'

import type { GridItem as Item } from '../CopyGrid/CopyGrid'

export interface CopyAllButtonProps {
  /**
   * Items to copy.
   */
  items: Item[]
}

export const CopyAllButton: React.FC<CopyAllButtonProps> = ({ items }) => {
  const { loading, translationKey } = useSettlementCreditLine()
  const { t } = useTranslation(`modals.${translationKey}`)

  const [copyIconName, setCopyIconName] = useState<
    'CheckOutline' | 'DuplicateOutline'
  >('DuplicateOutline')

  const handleCopyAllClick = useCallback(() => {
    /* Combine all items into a single, formatted string */
    const textToCopy = items.reduce((acc, { label, value }) => {
      /* Only add a new line if there is an existing value */
      const existingText = acc ? `${acc}\n\n` : ''

      return value ? `${existingText}${label}\n${value}` : acc
    }, '')

    void navigator.clipboard.writeText(textToCopy)

    setCopyIconName('CheckOutline')

    setTimeout(() => {
      setCopyIconName('DuplicateOutline')
    }, 3000)
  }, [items])

  if (loading) return null
  return (
    <TextLink onClick={handleCopyAllClick} variant="primary">
      <Icon className="text-icon-primary" name={copyIconName} size={24} />
      <span>{t(`depositInstructions.copyAllLabel`)}</span>
    </TextLink>
  )
}
